import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorFormatter } from '../../../shared/formatter/error.formatter';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { TrackAnalyticsService } from '../../../shared/services/track-analytics/track-analytics.service';
import { PhoneService } from '../../../shared/services/utils/phone.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { WhatsappSenderComponent } from '../../shared-component/forms/whatsapp-sender/whatsapp-sender.component';
import { ModalsHandlerService } from '../modals.handler.service';
@Component({
  selector: 'ngx-send-whatsapp',
  templateUrl: './send-whatsapp.component.html',
  styleUrls: []
})
export class SendWhatsappComponent extends WhatsappSenderComponent implements OnInit, AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;

  constructor(
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    protected readonly formBuilder: FormBuilder,
    protected readonly spinner: NgxSpinnerService,
    protected readonly leadService: LeadService,
    protected readonly toasterService: ToastService,
    protected readonly leadComuService: LeadsComunicationService,
    protected readonly translator: TranslatorService,
    protected readonly errorFormatter: ErrorFormatter,
    protected readonly trackAnalytics: TrackAnalyticsService,
    protected readonly phoneService: PhoneService,
  ) {
    super(formBuilder, spinner, leadService, toasterService, leadComuService,
      translator, errorFormatter, trackAnalytics, phoneService
    );
  }

  ngAfterViewInit(): void {
    this.modalsHandler.sendWhatsappModal.subscribe(data => {
      this.leadId = data.leadId;
      this.contactPhone = data.contactPhone;
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        });
    });
  }

  handlerWhatsappSended() {
    this.modalService.dismissAll();
  }

  send() {
    this.leadService.sendWhatsAppContact$(this.whatsappContactInput).subscribe(this.whatsappSendedHandler, this.whatsappSendedError);
  }

}
